import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { Wall } from 'types';

export const shareWall = ({
  wallId,
  userId,
  saveOverWall,
}: {
  wallId: number;
  userId: number;
  saveOverWall: number;
}): Promise<Wall> => {
  return axios.put(
    `/api/walls/${wallId}/users/${userId}/share/${saveOverWall}`
  );
};

type UseShareWallOptions = {
  config?: MutationConfig<typeof shareWall>;
};

export const useShareWall = ({ config }: UseShareWallOptions = {}) => {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['walls']);
    },
    ...config,
    mutationFn: shareWall,
  });
};
